<template>
  <div id="app" v-bind:class="sizing">
    <MTVNav />
    <router-view />
  </div>
</template>

<script>
import MTVNav from "@/components/MTVNav";
export default {
  components: {
    MTVNav,
  },
  computed: {
    sizing() {
      return this.$store.state.size;
    },
  },
  mounted() {
    window.dispatchEvent(new Event("resize"));
  },
};
</script>

<style lang="scss">
@import "@/assets/css/style.scss";
html, body {
  min-height: 100%;
}
body {
  color: #fff;
  background-image: url("./assets/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #95456d;
}
#app {
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
